import { render } from 'solid-js/web';
import { Panel } from './lib/Panel';
import { version } from '../package.json';
import { setComponentVersion } from '@formbird/solid-utils';

/**
 * solid-panel, solid-panel-collapse, and solid-static-html are registered as vanilla
 * custom elements WITHOUT shadow DOM.
 *
 * Shadow DOM is intentionally NOT used here because dynamic-container.component.ts
 * in the core app locates child elements (head, collapsable, triangle etc.) using
 * document.getElementById — which cannot pierce shadow DOM boundaries.
 *
 * solid-panel-collapse: collapsible by default (componentName triggers isCollapsible default true)
 * solid-panel: collapsible by default
 * solid-static-html: not collapsible by default (only collapsible if collapsible: true)
 */
class SolidPanelElement extends HTMLElement {
  // These properties are set directly by componentService.createComponent
  document: any;
  template: any;
  componentDefinition: any;
  fieldValue: any = '';
  fieldName: string = '';
  previousFieldValue: any = '';
  key: number = 0;
  formParameters: any;

  private _dispose: (() => void) | null = null;

  connectedCallback() {
    setComponentVersion(this, version);
    this._dispose = render(
      () => (
        <Panel
          document={this.document}
          template={this.template}
          componentDefinition={this.componentDefinition}
          fieldValue={this.fieldValue}
          fieldName={this.fieldName}
          previousFieldValue={this.previousFieldValue}
          key={this.key}
          formParameters={this.formParameters}
        />
      ),
      this
    );
  }

  disconnectedCallback() {
    this._dispose?.();
    this._dispose = null;
  }
}

if (!customElements.get('solid-panel')) {
  customElements.define('solid-panel', SolidPanelElement);
}

if (!customElements.get('solid-panel-collapse')) {
  customElements.define('solid-panel-collapse', class extends SolidPanelElement {});
}

if (!customElements.get('solid-static-html')) {
  customElements.define('solid-static-html', class extends SolidPanelElement {});
}

export { Panel };
